export function useMerchantPolicySettings(checkoutSession) {
  const policySettings = checkoutSession.policySettingsData;
  const consentCheckboxInfo = checkoutSession.consentCheckboxInfo;
  const displayAcknowledgementCheckbox = !!policySettings && policySettings.customPolicyEnabled && policySettings.acknowledgementRequired;
  return {
    policySettings,
    displayAcknowledgementCheckbox,
    consentCheckboxInfo
  };
}